module.exports = "../dist/frontend/icons/symbols/letters/a-gold.svg?99c67f9670d96f8446e7d036406beccc";